// 恶意网站黑名单
const blackList = ['meiqla.com', 'meiqiacontents.com', 'myrepoone.github.io'];

export default function filterBlackList(content = '') {
  let res = content;
  blackList.map(black => {
    if (content?.includes(black)) {
      res = '#';
    }
  });

  return res;
}
